(function () {
  function initList(list) {
    if (!list || list.dataset.progressTimelineInit === "true") {
      return;
    }

    list.dataset.progressTimelineInit = "true";

    var items = Array.prototype.slice.call(list.querySelectorAll(".progress-timeline__item"));

    if (!items.length) {
      return;
    }

    var ticking = false;

    function setActive(activeItem) {
      items.forEach(function (item) {
        item.classList.toggle("is-active", item === activeItem);
      });
    }

    function update() {
      var marker = window.innerHeight * 0.35;
      var current = items[0];

      items.forEach(function (item) {
        if (item.getBoundingClientRect().top <= marker) {
          current = item;
        }
      });

      setActive(current);
    }

    setActive(items[0]);

    window.addEventListener(
      "scroll",
      function () {
        if (ticking) {
          return;
        }

        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener("resize", update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll(".progress-timeline__list").forEach(initList);
  }

  initAll();

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
